<script lang="ts" setup>
// Modal genérico de 1 solo botón con ícono: aviso/resultado sin decisión de sí/no. Es el componente que renderiza
// `warnModal()` de `@/composables/modalHelper.ts` (no se instancia a mano). `type` define ícono+color fijo
// ('warning' triángulo naranja, 'success' check verde, 'error' carita roja); para íconos sin tipo predefinido
// (ej. calendario/reloj) pasar `icon` con la clase de FontAwesome, que siempre se pinta en violeta. Ver ejemplos de
// uso en `Totems.vue` y `RetailMediaCircuits.vue`.
import { computed } from 'vue';
import PolyButton from '@/components/poly/PolyButton.vue';
import type { VNodeChild } from 'vue';
const props = withDefaults(defineProps<{
  resolve: (value: unknown) => void
  title: string,
  text?: string,
  list?: string[],
  bottomText?: string,
  renderFunction?: () => VNodeChild
  showCancel?: boolean
  type?: 'warning' | 'success' | 'error'
  icon?: string
  confirmText?: string
}>(), {
  type: 'warning',
})

// Ícono y color según el tipo de aviso. Un ícono custom (caso "Sistema": mensajes sin tipo predefinido) siempre se pinta en violeta
const iconClass = computed(() => props.icon || { warning: 'fa-triangle-exclamation', success: 'fa-circle-check', error: 'fa-face-dizzy' }[props.type])
const iconColorClass = computed(() => props.icon ? 'icon-system' : `icon-${props.type}`)
</script>
<template lang="pug">
.warnWindow.pmx-col
  i.fa-light.warn-icon(:class="[iconClass, iconColorClass]")
  .main.pmx-col
    strong {{ title }}
    span(v-if="text") {{ text }}
    div(v-if="renderFunction")
      Component(:is="renderFunction()")
  .warn-list.pmx-col.pmx-scr-y(v-if="list?.length")
    span.warn-list-item(v-for="item in list" :key="item") {{ item }}
  span(v-if="bottomText") {{ bottomText }}
  .footer.pmx-row.pmx-noflex
    PolyButton(v-if="showCancel" button-style="Outline" button-color="Grey" @click="resolve(false)") {{ $t('CANCELAR') }}
    PolyButton(@click="resolve(true)") {{ $t(confirmText || 'ACEPTAR') }}
</template>
<style lang="less" scoped>
@import '../frontend/mobile/themevars.less';

.warnWindow {
  background-color: white;
  min-width: 30.769em;
  max-width: 30.769em;
  border-radius: 0.923em;
  padding: 2.462em 1.846em;
  align-items: center;
  gap: 1.538em;
  text-align: center;
}

.warn-icon {
  font-size: 4.923em;

  &.icon-warning { color: #fbb03b; }
  &.icon-success { color: @feedbackGreen; }
  &.icon-error { color: @feedbackRed; }
  &.icon-system { color: @emphasis; }
}

.main {
  gap: 0.615em;
  align-items: center;

  strong {
    font-size: 1.308em;
    color: #1a1a1a;
    line-height: 1.4;
  }

  span {
    font-size: 1em;
    color: #999;
  }
}

.warn-list {
  align-self: stretch;
  background: #ededed;
  border-radius: 0.615em;
  padding: 0.923em 1.231em;
  max-height: 9.231em;
  overflow-y: auto;
  text-align: left;
  gap: 0.308em;
}

.warn-list-item {
  font-size: 1.077em;
  color: #444;
}

.footer {
  justify-content: center;
  gap: 0.77em;
}
</style>
